import React from 'react';
import LinkIcon from '../../../assets/images/link_icon.svg';
import T from 'prop-types';

export const AnchorLink = ({ text, url, icon, className, urlTrue }) => {
    return <>
        {urlTrue ?
            <div className={className}>
                <a href={url} target="_blank" className="anchorStyles text" style={{paddingTop:'3px'}}>
                <img className='hide' src={icon} /><span>{text}</span></a>
            </div>
            :
            <div className="bottomText"><span>{text}</span></div>
        }
    </>
};

AnchorLink.T = {
    text: T.string,
    className: T.string,
    urlTrue: T.bool

};

AnchorLink.defaultProps = {
    icon: LinkIcon,
    className: "anchorDiv",
    urlTrue: true
};
